import React, { useState } from "react";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

/**
 * Club bookings inside the pack's validity that this purchase is NOT paying
 * for. A client the desk booked months ahead can have more of these than the
 * pack holds, and listed in full they push everything else off a phone — so on
 * a phone, once the whole list (`totalChips`) runs past FOLD_ABOVE, they fold to
 * one line with a count and open on a tap. Shorter lists, and every desktop,
 * start open.
 */
const FOLD_ABOVE = 15;

function NotIncludedSection({ count, totalChips = count, children, sx }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
  // Follows the list's length until the client taps the toggle; from then on
  // their choice stands. The club's bookings arrive and get ticked after the
  // tray first draws, so a one-off decision would count the wrong list.
  const [chosen, setChosen] = useState(null);
  const open = chosen ?? !(isMobile && totalChips > FOLD_ABOVE);

  if (count === 0) return null;

  return (
    <Box sx={{ pb: 1.25, ...sx }}>
      <ButtonBase
        onClick={() => setChosen(!open)}
        aria-expanded={open}
        sx={{ display: "flex", alignItems: "center", gap: 0.25, borderRadius: 1, color: "text.secondary" }}
      >
        <Typography variant="caption" sx={{ fontWeight: 700 }}>
          Not included ({count})
        </Typography>
        {open ? <ExpandLessIcon sx={{ fontSize: "1.125rem" }} /> : <ExpandMoreIcon sx={{ fontSize: "1.125rem" }} />}
      </ButtonBase>
      <Collapse in={open}>
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.25, mb: 0.5 }}>
          Already booked by the club — tap to let this pack pay for {count === 1 ? "it" : "them"}, or ✕ to cancel
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>{children}</Box>
      </Collapse>
    </Box>
  );
}

export default NotIncludedSection;
